/**
 * Returns the earliest date from the provided dates.
 *
 * @param dates - An array of Date objects to compare.
 * @returns The earliest date.
 */
export const getMinDate = (...dates: [Date, ...Date[]]): Date => {
    return dates.reduce((minDate, date) => (date < minDate ? date : minDate));
};
